import React, { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Skeleton, Typography } from '@mui/material';
import { BarChart } from '../../../shared';
import { TOP_REACH_CHART_OPTIONS } from './constants';
import { customCategories } from '../../../../utility';

const TopCTRChart = () => {
    const { company } = useSelector((state) => state.company) || {};
    const { dtcData } = useSelector((state) => state.paidSearch);
    const { isPaidSearchLoading, topCTRChart } = dtcData;
    const { categories,data } = topCTRChart;
    const { isCostApiLoading } = useSelector((state) => state.webMatrix);
    const isLoading = ( isCostApiLoading || isPaidSearchLoading);
    const barChartOptions = useMemo(() => ({
        ...TOP_REACH_CHART_OPTIONS,
        xaxis: {
            ...TOP_REACH_CHART_OPTIONS.xaxis,
            categories: categories
        },
        plotOptions: {
            ...TOP_REACH_CHART_OPTIONS.plotOptions,
            bar: {
                ...TOP_REACH_CHART_OPTIONS.plotOptions.bar,
                barHeight: categories.length ===1 ? 45 : '100%'
            }
        },
        tooltip: {
            enabled: true,
            marker: { show: false },
            custom: function({
                series, seriesIndex, dataPointIndex, w 
            }) {
                const item = data[dataPointIndex];
                return `<div style="padding: 8px; background: white; border-radius: 4px; box-shadow: 0px 0px 4px rgba(0,0,0,0.2);">
                            <p style="margin: 0; font-size: 14px; font-weight: bold;">${w.globals.labels[dataPointIndex]}</p>
                            <p style="margin: 0;">CTR: <span style="font-weight: bold;">${item.totalPercentage}%</span></p>
                        </div>`;
            }
        }
        
        
        
    }), [categories, data]);
    
    const [key, setKey] = useState(0);

    useEffect(() => {
        setKey((prevKey) => prevKey + 1);
    }, [company]);
    const chartSeries = useMemo(() => [
        {
            name: '',
            data: data.map(item => item.totalPercentage) // Only numbers
        }
    ], [data]);
    return (
        <Box className="container-p-24-br-16 bg-gray-50 height-100">
            <Box>
                <Typography className="text-md-medium gray-900">
                Top Keywords by CTR
                </Typography>
                <Typography className="text-sm-regular gray-500" sx={{ marginTop: '4px' }}>
                * Minimum 200 Impressions
                </Typography>
            </Box>

            <Box className="wh-100" id="engagement-deciles">
                {isLoading ? (
                    <Skeleton height={400} variant="rectangular" width="100%" />
                ) : (
                    <BarChart
                        chartOptions={barChartOptions}
                        chartSeries={chartSeries}
                        height={'300px'}
                        key={key}
                    />
                )}
            </Box>
        </Box>
    );
};

export default TopCTRChart;
